import { getDraftSourceLabel } from '../../utils/draftUtils';
import Icon from './Icon';

// Returns null on missing/invalid so callers drop "Updated at …".
function formatGeneratedAt(value) {
  if (value === undefined || value === null || value === '') return null;
  const d = new Date(value);
  if (Number.isNaN(d.getTime())) return null;
  return d.toLocaleTimeString('en-IN', { hour: '2-digit', minute: '2-digit' });
}

export default function DraftStatusChip({
  show,
  loading,
  draftStatus,
  lastDraftMeta,
}) {
  if (!show) return null;

  const updatedAtLabel = formatGeneratedAt(lastDraftMeta?.generatedAt);
  const latencySeconds = lastDraftMeta?.latencyMs
    ? Math.max(1, Math.round(lastDraftMeta.latencyMs / 1000))
    : null;

  return (
    <div className="absolute top-3 right-0 z-20 flex justify-end px-4 pt-3 pointer-events-none">
      <div
        className="max-w-[360px] rounded-2xl border px-3 py-2 backdrop-blur-md shadow-[0_10px_28px_rgba(8,17,31,0.18)]"
        style={{
          borderColor: 'rgba(255,255,255,0.45)',
          background: loading ? 'rgba(20,95,95,0.22)' : 'rgba(255,255,255,0.52)',
          color: '#102437',
        }}
      >
        <div className="flex items-center gap-2 text-[11px] font-semibold">
          <span className={`leading-none ${loading ? 'animate-pulse' : ''}`} style={{ color: loading ? '#145f5f' : '#4a6b3f' }}>
            <Icon name={loading ? 'pending' : 'success'} size={13} />
          </span>
          <span>{draftStatus}</span>
        </div>
        {!loading && lastDraftMeta ? (
          <div className="mt-1 text-[10px] text-[#394b61]">
            {updatedAtLabel && <>Updated at {updatedAtLabel}</>}
            {updatedAtLabel && latencySeconds != null && ' · '}
            {latencySeconds != null && `${latencySeconds}s`}
            {lastDraftMeta.attempts ? ` · ${lastDraftMeta.attempts} attempt${lastDraftMeta.attempts > 1 ? 's' : ''}` : ''}
            {(updatedAtLabel || latencySeconds != null || lastDraftMeta.attempts) && ' · '}
            {getDraftSourceLabel(lastDraftMeta.source, lastDraftMeta.cacheHit)}
          </div>
        ) : (
          <div className="mt-1 text-[10px] text-[#394b61]">Preview stays usable while AI runs</div>
        )}
      </div>
    </div>
  );
}
